import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface TimerState {
  enabled: boolean
  value: number
  endValue: number
}

interface DropdownState {
  items: string[]
  selected: string | null
}

interface HeaderState {
  timer: TimerState
  avatar: string
  pageTitle: string
  dropdown: DropdownState
}

const initialState: HeaderState = {
  timer: {
    enabled: false,
    value: 3599,
    endValue: 0,
  },
  avatar: "",
  pageTitle: "",
  dropdown: {
    items: [],
    selected: null,
  },
}

const baseStore = createSlice({
  name: "header",
  initialState: initialState,
  reducers: {
    setTimerEnabled: (state, action: PayloadAction<boolean>) => {
      state.timer.enabled = action.payload
    },
    setPageTitle: (state, action: PayloadAction<string>) => {
      state.pageTitle = action.payload
    },
    setTimerValue: (state, action: PayloadAction<number>) => {
      state.timer.value = action.payload
    },
  },
})

export const { setTimerEnabled, setPageTitle, setTimerValue } = baseStore.actions

export default baseStore.reducer
